import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import getNameByID from "../../../../../functions/getNameByID";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PaidIcon from "@mui/icons-material/Paid";
import { Get_limited_From_MongoDB_With_Search } from "../../../../api/Get_limited_From_MongoDB_With_Search";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";

function Payments({ Attendee, setAttendee, Staff, id }) {
  const { logout } = StaffuseAuth();

  let InvoiceProps = [
    "_id",
    "Invoice_Number",
    "SubAmount",
    "Amount",
    "DateTime",
    "Due_Date",
    "Paid_Date",
    "Paid_Status",
  ];

  const [Invoices, setInvoices] = useState([]);
  useEffect(() => {
    if (id !== "AddAttendee") {
      Get_limited_From_MongoDB_With_Search(
        "Invoices",
        "Xero_2025",
        { "Attendees.Attendee_id": id },
        1000,
        setInvoices,
        logout
      );
    }
  }, []);

  let InvoiceLines = [];
  Invoices.forEach((invoice) => {
    invoice.Attendees.forEach((attendee) => {
      if (attendee.Attendee_id === id) {
        InvoiceLines.push({
          //
          _id: invoice._id,
          Invoice_Number: invoice.Invoice_Number,
          Amount: invoice.Amount,
          CreditNote_AmountUsed: invoice.CreditNote_AmountUsed,
          CreditNote_Used: invoice.CreditNote_Used,
          DateTime: invoice.DateTime,
          Due_Date: invoice.Due_Date,
          Paid_Date: invoice.Paid_Date,
          Paid_Status: invoice.Paid_Status,
          //
          Source: attendee.Source,
          Attendee_id: attendee.Attendee_id,
          SubAmount: attendee.SubAmount,
        });
      }
    });
  });

  //--------------------------------------------------------------------------------

  return (
    <section>
      <section>
        <h2>Payments </h2>
      </section>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              {InvoiceProps.map((item, index) => (
                <TableCell
                  key={index} // Add a unique key prop
                  className="tableCellHeader" // Add this line to include the CSS class
                  align="left"
                  style={{
                    position: "sticky",
                    Top: 0,
                    zIndex: 1,
                    fontWeight: "bold", // Make Text bold
                    padding: "8px", // Adjust padding as needed To make cells smaller
                  }}
                >
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {InvoiceLines && Array.isArray(InvoiceLines) ? (
              InvoiceLines.map((InvoiceLine, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                      "& .MuiTableCell-root": {
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word", // Adjust padding here to make cells smaller
                      },
                    },
                  }}
                  style={{
                    backgroundColor:
                      InvoiceLine["Paid_Status"] === "Paid"
                        ? "#c3e6cb"
                        : "#f5c6cb",
                  }}
                >
                  {InvoiceProps.map((element, index) => (
                    <TableCell
                      key={index} // Add a unique key prop
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {InvoiceLine[element]}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <></>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ marginTop: "20px" }}></div>
    </section>
  );
}

export default Payments;
